export default __webpack_public_path__ + "static/media/6_W7XH55-min.ad2acfc3.jpg";